// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1___d51925c807aeaf9cda7{/*!*/}.CreateSocialItem-cls2___45e8965f77ff30d6482{display:flex;align-items:center;justify-content:space-between}@media(min-width: 768px){.CreateSocialItem-cls2___45e8965f77ff30d6482{margin:-16px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1___d51925c807aeaf9cda7",
	"cls2": "CreateSocialItem-cls2___45e8965f77ff30d6482 CreateSocialItem-cls1___d51925c807aeaf9cda7"
};
export default ___CSS_LOADER_EXPORT___;
